import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CaseService } from 'app/main/shared/services/case.service';
import { StripePaymentService } from 'app/main/shared/services/stripePayment.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-payment-form',
  templateUrl: './payment-form.component.html',
  styleUrls: ['./payment-form.component.scss']
})
export class PaymentFormComponent implements OnInit {
  paymentForm: FormGroup;
  
  loading = false;

  payments: any;

  duePayment: any;

  constructor(public dialogRef: MatDialogRef<PaymentFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private formBuilder: FormBuilder, 
    private stripePaymentService: StripePaymentService, private caseService: CaseService) { }

  ngOnInit() {
    this.paymentForm = this.formBuilder.group({
      message: ['', Validators.compose([Validators.required, Validators.minLength(10), Validators.maxLength(250)])]
    });
    if(this.data) {
      this.getPayments();
    }
  }

  getPayments() {
    this.loading = true;
    this.stripePaymentService.getStripePaymentsByCaseId('',this.data.id)
      .subscribe(result => {
        this.loading = false;
        this.payments = result;
        this.duePayment = _.find(this.payments, ['transaction_status', 'Due']);
      },
      Error => {
        this.loading = false;
        console.log(Error);
      });
  }

  updatePayment() {
    this.loading = true;
    let payFormRequest = this.paymentForm.value;
    this.stripePaymentService.updateStripePayment(this.duePayment.id, this.duePayment.caseid, {"msg": payFormRequest.message})
      .subscribe(result => {
      this.loading = false;
      if(this.duePayment.description == 'Inventory Amount Paid') {
        this.loading = true;
        this.caseService.getCaseById('', this.duePayment.caseid)
          .subscribe(data => {
            this.loading = false;
            let orgId = data.summary.organization_id;
            let formData = {
              status: 'INVENTORY_AMOUNT_PAID'
            };
            this.loading = true;
            this.caseService.putCaseNew(orgId, this.duePayment.caseid, formData)
              .subscribe(result => {
                this.loading = false;
                this.dialogRef.close(true);
              });
          }, Error => {
            this.loading = false;
            console.log(Error);
          });
      }
      else {
        this.loading = false;
        this.dialogRef.close(true);
      }
      
    },
    Error => {
      this.loading = false;
      console.log(Error);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/common/payments/payment-form/payment-form.component.ts